<ion-content [fullscreen]="true">
  <div class="help">
    <!--    <div class="user-info">-->
    <!--      {{userUid}}-->
    <!--    </div>-->

    <app-background [justBackground]="true"></app-background>
    <!--    <h2>Help center!</h2>-->
    <!--    <button class="download" (click)="sendUserDataEmail()">Verstuur game data</button>-->
    <!--    <button class="download-2" (click)="sendNotification()">stuur notificatie</button>-->

    <div [routerLink]="'/send-data'" class="data-symbol">
      <!--      <img src="../../assets/icons/question-mark.svg" alt="">-->
      <span class="export-icon material-symbols-outlined"> file_upload </span>
    </div>

    <div class="human">
      <app-human-text-cloud [bottom]="'calc(var(--ion-safe-area-bottom) - 27px)'" class="human-illustration"></app-human-text-cloud>

      <div [innerHTML]="general?.helpText | marked" class="text"></div>
    </div>
  </div>
</ion-content>
